import Service from "../DepartmentService";

function GetByDepartmentAndTerm(termId) {
    return Service.get('OfficeHour/GetByDepartmentAndTerm?termId=' + termId);
}

function GetByDepartmentAndTermByMemberId(termId, memberId) {
    return Service.get('OfficeHour/GetByDepartmentAndTermByMemberId?termId=' + termId + '&memberId=' + memberId);
}



const OfficeHourService = {
    GetByDepartmentAndTerm,
    GetByDepartmentAndTermByMemberId
};

export default OfficeHourService;
